"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiOptionsInput = void 0;
const React = require("react");
const standardizeOptions_1 = require("../../../../helpers/standardizeOptions");
const isValueInOptions_1 = require("../../../../helpers/isValueInOptions");
const TextInput_1 = require("../TextInput");
class MultiOptionsInput extends React.Component {
    constructor(props) {
        super(props);
        // Sets the values
        this.setValue = (value) => {
            this.setState({ value: value });
            this.props.onInputChange(value);
        };
        this.selectValues = (evt, options) => {
            // Look the value up by index, thereby honouring its original type. Allows for
            // numeric values
            // NOTE: evt.selectedOptions is not supported in older browsers or styleguidist
            const clickedOptions = evt.target.options || [];
            let value = [];
            // map over clicked.options
            // TODO evt.target.options is an object. Cant map an object
            for (let i = 0; i < clickedOptions.length; i++) {
                if (clickedOptions[i].selected) {
                    value.push(clickedOptions[i].value);
                }
            }
            this.setValue(value.map(o => {
                return options[parseInt(o)].value;
            }));
        };
        // Sanitize props to make sure they are an array
        this.state = {
            value: props.value
        };
        this.options = (0, standardizeOptions_1.standardizeOptions)(this.props.options);
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ value: nextProps.value });
    }
    render() {
        const { value } = this.state;
        const selectedIndicies = this.options
            .map((option, index) => {
            return value.indexOf(option.value) > -1 ? index.toString() : false;
        })
            .filter((n) => {
            return n;
        });
        if (!(0, isValueInOptions_1.isValueInOptions)(this.options, this.props.value)) {
            return (React.createElement(TextInput_1.TextInput, { onInputChange: () => { }, disabled: true, value: this.state.value }));
        }
        return (React.createElement("select", { "data-test": "input", onChange: evt => {
                this.selectValues(evt, this.options);
            }, value: selectedIndicies, multiple: true, disabled: this.props.disabled }, this.options.map((v, i) => (React.createElement("option", { key: v.label, value: i }, v.label)))));
    }
}
exports.MultiOptionsInput = MultiOptionsInput;
//# sourceMappingURL=index.js.map